/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Audio from 'assets/sounds/notification.wav';
import VezeetaImg from 'assets/images/logo-blue.svg';
import { getAuthCookieInfo } from 'utils/functions/authentication';

const WS_URL = `${process.env.REACT_APP_WS}`;

const PushNotificationComponent = ({ callBack, onChange }) => {
  const { pharmacyKey, authCookie } = getAuthCookieInfo();
  const wsRef = useRef(null);
  const reconnectTimeout = useRef(null);
  const heartbeatInterval = useRef(null);
  /** After full-page login, autoplay resets; one gesture unlocks sound for later WS events. */
  const audioUnlockedRef = useRef(false);

  const log = msg => {
    console.log('[Pharmacy WS]', msg);
  };

  const sendPushNotification = data => {
    const { pharmacyKey: key } = getAuthCookieInfo();
    if (!key) return;

    const { orderNumber, orderKey } = data;
    const audioElement = document.getElementById('notification-audio');

    if (audioElement) {
      audioElement.loop = true;
      audioElement.muted = false;
      const playPromise = audioElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          /* Autoplay blocked until user interacts with the document */
        });
      }
    }
    onChange();

    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        const notification = new Notification('New Order Recieved!', {
          body: `Order #${orderNumber}`,
          image: VezeetaImg,
          icon: VezeetaImg,
          badge: VezeetaImg,
        });

        notification.onclick = () => {
          callBack(orderKey);

          if (audioElement) {
            audioElement.loop = false;
            audioElement.pause();
          }
        };
      }
    });
  };

  /* const subscribe = () => {
    const payload = {
      action: 'subscribe',
      pharmacyKey,
    };

    wsRef.current.send(JSON.stringify(payload));
    log(`Subscribed → ${JSON.stringify(payload)}`);
  };
 */
  const startHeartbeat = () => {
    heartbeatInterval.current = setInterval(() => {
      if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({ action: 'ping' }));
      }
    }, 60000); // 1 minute
  };

  const stopHeartbeat = () => {
    if (heartbeatInterval.current) {
      clearInterval(heartbeatInterval.current);
    }
  };

  const connect = () => {
    log('Connecting WebSocket...');
    wsRef.current = new WebSocket(
      `${WS_URL}?CKey=${pharmacyKey}&BkType=20&CType=1&AccKey=${pharmacyKey}&BrKey=${pharmacyKey}`,
      [authCookie],
    );

    wsRef.current.onopen = () => {
      log('Connected');

      // subscribe();
      startHeartbeat();
    };

    wsRef.current.onmessage = event => {
      log(`Message → ${event.data}`);

      try {
        const data = JSON.parse(event.data);
        console.log('data', data);
        if (data.event === 'order_created') {
          sendPushNotification(data);
        }
      } catch (err) {
        console.error('WebSocket parse error', err);
      }
    };

    wsRef.current.onerror = error => {
      console.error('WebSocket error', error);
    };

    wsRef.current.onclose = () => {
      log('Connection closed');

      stopHeartbeat();

      reconnectTimeout.current = setTimeout(() => {
        connect();
      }, 2000);
    };
  };

  useEffect(() => {
    if (!pharmacyKey) return undefined;

    const unlockAudio = () => {
      const el = document.getElementById('notification-audio');
      if (!el || audioUnlockedRef.current) return;
      el.muted = true;
      const p = el.play();
      if (p !== undefined) {
        p.then(() => {
          el.pause();
          el.currentTime = 0;
          audioUnlockedRef.current = true;
        }).catch(() => {});
      }
      document.removeEventListener('pointerdown', unlockAudio);
    };
    document.addEventListener('pointerdown', unlockAudio);

    Notification.requestPermission();

    connect();

    return () => {
      document.removeEventListener('pointerdown', unlockAudio);
      stopHeartbeat();

      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }

      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [pharmacyKey]);

  return <audio muted id="notification-audio" controls src={Audio} style={{ display: 'none' }} />;
};

PushNotificationComponent.propTypes = {
  callBack: PropTypes.func,
  onChange: PropTypes.func,
};

export default PushNotificationComponent;
